import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { SplitText } from 'gsap/SplitText';
import { Observer, Flip } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText, Observer, Flip);

export { gsap, ScrollTrigger, ScrollToPlugin, SplitText, Observer, Flip };
